"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterContextItemsToFiltersForWidget = exports.filterContextToFiltersForWidget = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
var isString_1 = tslib_1.__importDefault(require("lodash/isString"));
/**
 * Gets {@link IDashboardFilter} items for filters specified in given filterContext in relation to the given widget.
 *
 * @param filterContext - filter context to get filters for
 * @param widget - widget to use to get dateDataSet for date filters
 * @internal
 */
function filterContextToFiltersForWidget(filterContext, widget) {
    if (!filterContext) {
        return [];
    }
    return filterContextItemsToFiltersForWidget(filterContext.filters, widget);
}
exports.filterContextToFiltersForWidget = filterContextToFiltersForWidget;
/**
 * Gets {@link IDashboardFilter} items for filters specified as {@link FilterContextItem} instances.
 *
 * @param filterContextItems - filter context items to get filters for
 * @param widget - widget to use to get dateDataSet for date filters
 * @internal
 */
function filterContextItemsToFiltersForWidget(filterContextItems, widget) {
    return filterContextItems.map(function (filter) {
        if (sdk_backend_spi_1.isDashboardAttributeFilter(filter)) {
            if (filter.attributeFilter.negativeSelection) {
                return sdk_model_1.newNegativeAttributeFilter(filter.attributeFilter.displayForm, filter.attributeFilter.attributeElements);
            }
            else {
                return sdk_model_1.newPositiveAttributeFilter(filter.attributeFilter.displayForm, filter.attributeFilter.attributeElements);
            }
        }
        else {
            if (filter.dateFilter.type === "relative") {
                return sdk_model_1.newRelativeDateFilter(widget.dateDataSet, filter.dateFilter.granularity, numberOrStringToNumber(filter.dateFilter.from), numberOrStringToNumber(filter.dateFilter.to));
            }
            else {
                return sdk_model_1.newAbsoluteDateFilter(widget.dateDataSet, filter.dateFilter.from.toString(), filter.dateFilter.to.toString());
            }
        }
    });
}
exports.filterContextItemsToFiltersForWidget = filterContextItemsToFiltersForWidget;
function numberOrStringToNumber(input) {
    return isString_1.default(input) ? Number.parseInt(input) : input;
}
//# sourceMappingURL=converters.js.map